(function () {
  const SECTION_SELECTOR = '[data-hopw-stats]';
  const CARD_SELECTOR = '[data-hopw-stat]';
  const NUMBER_SELECTOR = '[data-hopw-stat-number]';
  const DURATION_MS = 1400;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function animateStat(card) {
    if (card.dataset.hopwStatAnimated === 'true') return;
    card.dataset.hopwStatAnimated = 'true';

    const target = parseInt(card.dataset.statTarget, 10) || 0;
    const numberEl = card.querySelector(NUMBER_SELECTOR);

    if (prefersReducedMotion()) {
      if (numberEl) numberEl.textContent = String(target);
      card.style.setProperty('--stat-pct', target + '%');
      card.classList.add('is-animated');
      return;
    }

    const start = performance.now();

    function tick(now) {
      const progress = Math.min((now - start) / DURATION_MS, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(target * eased);

      if (numberEl) numberEl.textContent = String(current);
      card.style.setProperty('--stat-pct', current + '%');

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        card.classList.add('is-animated');
      }
    }

    requestAnimationFrame(tick);
  }

  function initSection(section) {
    if (!section || section.dataset.hopwStatsInit === 'true') return;
    section.dataset.hopwStatsInit = 'true';

    const cards = section.querySelectorAll(CARD_SELECTOR);
    if (!cards.length) return;

    if (!('IntersectionObserver' in window)) {
      cards.forEach(animateStat);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateStat(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3, rootMargin: '0px 0px -8% 0px' }
    );

    cards.forEach((card) => observer.observe(card));
  }

  function boot(container) {
    const scope = container || document;
    scope.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      section.dataset.hopwStatsInit = '';
      section.querySelectorAll(CARD_SELECTOR).forEach((card) => {
        card.dataset.hopwStatAnimated = '';
        card.classList.remove('is-animated');
        card.style.setProperty('--stat-pct', '0%');
        const numberEl = card.querySelector(NUMBER_SELECTOR);
        if (numberEl) numberEl.textContent = '0';
      });
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });
})();
